import { HANDLE_ERRORS, HANDLE_SUCCESS, FILE_SAVED } from "../actions/types";

const INITIAL_STATE = {
  message: "",
  open: false,
  color: "red"
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HANDLE_ERRORS:
      return {
        ...state,
        message: action.payload.message,
        open: action.payload.open,
        variant: "error"
      };
    case HANDLE_SUCCESS:
      return {
        ...state,
        message: action.payload.message,
        open: action.payload.open,
        variant: "success"
      };
    case FILE_SAVED:
      return {
        ...state,
        message: action.payload.message,
        open: true,
        variant: "success"
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/errors_reducers.js